module.exports = __webpack_public_path__ + "img/step_4.8225e4ab.png";